import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/workpath0/projects/website/src/templates/MDXPage/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "https://github.com/yisar/fre"
      }}>{`Fre`}</a></p>
    <blockquote>
      <p parentName="blockquote">{`Tiny Reac16 like framework with Concurrent`}</p>
    </blockquote>
    <p>{`Seems like a potentially interesting alternative to React.`}</p>
    <p>{`However, I saw a flash-of-unrendered-content, so unclear whether it's ready for primetime yet.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      